import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { getProjectCancellationApplicationIncludes } from 'sh-www/constants/routes/project-cancellation';

class ProjectCancellationRoute extends Route {
  @service('commands/application-commands') applicationCommandService;
  @service session;

  async model({ projectIdOrSlug }) {
    const response = await this.applicationCommandService.loadApplication(
      projectIdOrSlug,
      getProjectCancellationApplicationIncludes(this.session.currentUser)
    );
    return this.applicationCommandService._pushApplicationResponseToStore(response);
  }
}

export default ProjectCancellationRoute;
